(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-sidebar"] && !Shopify.designMode) return;
  try {
    (() => {
    const container = document.currentScript?.closest('.collection-sidebar-block');
    if (!container) return;
    if (container.hasAttribute('data-sticky')) {
      container.classList.add('collection-sidebar-block--sticky');
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
